import React from 'react';
import { Link } from 'react-router-dom';
import TableLoader from './TableLoader';

const AvisosTable = ({ 
  avisos, 
  loading
}) => {
  if (loading) {
    return <TableLoader />;
  }

  return (
    <div className="table-responsive">
      <table className="table align-items-center mb-0">
        <thead>
          <tr>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Aviso</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nível</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ações</th>
          </tr>
        </thead>
        <tbody>
          {avisos.map((aviso) => (
            <tr key={aviso.id}>
              <td className="text-xs mb-0">{aviso.description}</td>
              <td className="text-xs mb-0">
                <span className={`badge ${aviso.notificationLevel === 0 ? 'bg-success' : 'bg-warning'}`}>
                  {aviso.notificationLevel === 0 ? 'Normal' : 'Importante'}
                </span>
              </td>
              <td className="text-xs font-weight-bold mb-0">
                <Link to={`/Avisos/Editar/${aviso.id}`} title="Editar" className="me-3">
                  <i className="bi bi-pencil-square text-primary"></i>
                </Link>
                <Link to={`/Avisos/Excluir/${aviso.id}`} title="Excluir">
                  <i className="bi bi-trash text-danger"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AvisosTable; 